import React from 'react'

const Footer = () => {
  return (
    <><div className="jp_main_footer_img_wrapper" style={{ marginTop: "auto" }}>
    <div className="jp_newsletter_img_overlay_wrapper" style={{backgroundColor:'black'}} />
    {/* jp Newsletter Wrapper End */}
    {/* jp footer Wrapper Start */}
    <div className="jp_footer_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom:-50}}>
            <div className="jp_footer_logo_wrapper">
              <div className="jp_footer_logo">
                <a href="/">
                  <img style={{width:"300px", height:"100%", marginTop:30}} src="https://biyomed.net/kariyer_images/biyomedlogosiyahzemin2.png" alt="footer_logo" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_bottom_footer_Wrapper">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="jp_bottom_footer_left_cont">
                    <p>©2020 Biyomedikal Mühendisleri Derneği</p>
                  </div>
                  <div className="jp_bottom_top_scrollbar_wrapper">
                    <a
                      href="/"
                      id="return-to-top"
                      style={{ display: "inline" }}
                    >
                      <i className="fa fa-angle-up" />
                    </a>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <div className="jp_bottom_footer_right_cont">
                  <ul>
                  <li>
                    <a href="https://www.linkedin.com/company/biyomed/">
                      <i className="fa fa-linkedin" />
                    </a>
                  </li>

                  <li>
                    <a href="https://www.instagram.com/biyomed.official/">
                      <i className="fa fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.youtube.com/channel/UCmy1lQQVYVuOEhWCQo0I2Hw">
                      <i className="fa fa-youtube" />
                    </a>
                  </li>

                  <li>
                    <a href="https://x.com/biyomed">
                      <i className="fa fa-twitter" />
                    </a>
                  </li>
                </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></>




  )
}

export default Footer